"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateCleanUpCamera = void 0;
/**
 * This migration got introduced because we have dead data lingering around. This causes validation to fail.
 */
const migrateCleanUpCamera = async (dialog) => {
    const branch = dialog.scenes.scene1.branches.start;
    branch.steps.forEach((step) => {
        const anyStep = step;
        if (step.camera) {
            delete anyStep.camera.layout;
            delete anyStep.camera.mode;
        }
        step = anyStep;
    });
    return dialog;
};
exports.migrateCleanUpCamera = migrateCleanUpCamera;
//# sourceMappingURL=migrateCleanUpCamera.js.map